export default "__VITE_ASSET__CXPmYVfH__"